import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { StyleAppHelper } from './providers/style-app-helper';

import { OnWacUiLibModule } from 'on-wac-ui-lib';
import { FlexiformsLibraryModule } from 'flexiforms-library';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { FormComponent } from './components/form/form.component';

// Services
import { SiteApiService } from '@services';

// Pipes
import { SafeHtml } from './pipes/safe-html.pipe';

@NgModule({
    declarations: [AppComponent, NotFoundComponent, FormComponent, SafeHtml],
    imports: [
        BrowserModule,
        AppRoutingModule,
        OnWacUiLibModule,
        FlexiformsLibraryModule,
        HttpClientModule,
    ],
    providers: [StyleAppHelper, SiteApiService],
    bootstrap: [AppComponent],
})
export class AppModule {}
